// The note to the chauffeur: up to 300 characters and a few quick chips. The server is the judge (it refuses phone numbers, emails and links with a clear
// message); the page checks the same things first so the rider hears about it while typing.
export const MAX_NOTE = 300;
export const NOTE_CHIPS = ['Child on board', 'Extra luggage', 'Please call on arrival', 'Wheelchair / walker', 'Celebrating something'];
export const NOTE_BLOCK_MESSAGE = 'Please keep phone numbers, email addresses and links out of your note. Your contact details stay private, and your chauffeur can reach you through the app.';
export const NOTE_FOOTNOTE = "We'll pass this on to your chauffeur; special requests aren't guaranteed.";

const EMAIL = /[\w.+-]+\s*(@|\(at\)|\[at\]|\sat\s)\s*[\w-]+\s*(\.|\(dot\)|\[dot\]|\sdot\s)\s*[a-z]{2,}/i;
const URL_RE = /(https?:\/\/|www\.|\b[a-z0-9-]+\.(com|net|org|io|co|us|app|me|ly|gl|link|info|biz|xyz|nyc|gle)\b|\bbit\.ly\b|\btinyurl\b|\bwa\.me\b|\bt\.me\b)/i;
const DIGIT_RUN = /\+?\d[\d\s().-]{5,}\d/g;
const WORD_DIGITS = new Set(['zero', 'oh', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine']);

function spelledDigits(text) {
  let best = 0; let run = 0;
  (String(text).toLowerCase().match(/[a-z]+|\d/g) || []).forEach((w) => {
    if (WORD_DIGITS.has(w) || /^\d$/.test(w)) { run += 1; best = Math.max(best, run); } else run = 0;
  });
  return best;
}

export function hasContactDetails(text) {
  const t = String(text || '');
  if (EMAIL.test(t) || URL_RE.test(t)) return true;
  const runs = t.match(DIGIT_RUN) || [];
  if (runs.some((r) => r.replace(/\D/g, '').length >= 7)) return true;
  return spelledDigits(t) >= 7;
}

// '' when the note is fine, otherwise the sentence to show under the box.
export function noteProblem(text) {
  const t = String(text || '').trim();
  if (t.length > MAX_NOTE) return `Your note can be up to ${MAX_NOTE} characters.`;
  if (t && hasContactDetails(t)) return NOTE_BLOCK_MESSAGE;
  return '';
}

export function toggleChip(chips, chip) {
  const list = Array.isArray(chips) ? chips : [];
  return list.includes(chip) ? list.filter((c) => c !== chip) : [...list, chip];
}
